import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { FirebaseService } from '../../shared/services/firebase.service';

// eslint-disable-next-line func-style
export const unauthGuard: CanMatchFn = () => {
	const router = inject(Router);
	const auth = inject(FirebaseService).auth;

	const user = auth.currentUser;
	if (user) {
		return router.parseUrl('/');
	}
	return true;
};
